const FontsList = [
    "Camar",
    "Cremona",
    "IMBPlexonaMono",
    "Luxia",
    "Pioggia"
]

export default FontsList